import { FC, Fragment, ReactNode } from 'react'
import { useComponents } from '@/hooks'
import { GridEmpty, GridLoading, GridItem } from '@/ui/components'

export const PicsGridBuilder = (components: any) => {
    let grid: Array<Array<ComponentInterface>> = [[], [], [], [], []], index: number = 0

    for (const component of components) {
        if (index === 5) index = 0

        grid[index].push(component)
        index++
    }

    return { PicsGrid: grid }
}

const GridItems: FC = (): ReactNode => {
    const { Components, InfiniteEndReference } = useComponents()
    const { PicsGrid } = PicsGridBuilder(Components)

    return (
        <section className='max-h-[83.5vh] overflow-scroll min-h-[83.5vh]'>
            <div className='custom-scrollbar h-full mx-auto pb-2 px-2 grid gap-2 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'>
                {PicsGrid?.map((set_of_pics: any, listIndex: number) => {
                    return (
                        <div className='flex flex-col gap-2' key={listIndex}>
                            {set_of_pics?.map((component: ComponentInterface) => {
                                return (
                                    <Fragment key={component._id}>
                                        <GridItem {...component} />
                                    </Fragment>
                                )
                            })}
                        </div>
                    )
                })}
            </div>

            <div className='w-full h-[1px]' ref={InfiniteEndReference} />

            <GridEmpty />
            <GridLoading />
        </section>
    )
}

export default GridItems
